"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Timer = _interopRequireDefault(require("../Timer"));
var _Button = _interopRequireDefault(require("../Button"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _BookingStatus = _interopRequireDefault(require("./BookingStatus.proptypes"));
var _constant = require("./constant");
var _BookingStatusUtils = require("./BookingStatusUtils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__StyledContainer",
  componentId: "sc-9j6840-0"
})(["display:flex;flex-direction:column;background:", ";box-shadow:0px 1px 4px rgba(0,0,0,0.16);border-radius:4px;padding:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor.default;
}, function (_ref2) {
  var isMobile = _ref2.isMobile,
    theme = _ref2.theme;
  return isMobile ? theme.space.small : theme.space.standard;
});
var TimerWrapper = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__TimerWrapper",
  componentId: "sc-9j6840-1"
})(["display:flex;padding:", ";margin-left:", ";[class*='Timer']{", ";}"], function (_ref3) {
  var isMobile = _ref3.isMobile,
    theme = _ref3.theme;
  return isMobile ? theme.space.tiny : theme.space.small;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.small;
}, function (_ref5) {
  var showTimer = _ref5.showTimer;
  return !showTimer && "display: none";
});
var StyledContent = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__StyledContent",
  componentId: "sc-9j6840-2"
})(["display:flex;align-items:center;justify-content:flex-start;flex-direction:row;padding:", ";"], function (_ref6) {
  var theme = _ref6.theme,
    isMobile = _ref6.isMobile;
  return isMobile ? "".concat(theme.space.XSmall, " ").concat(theme.space.small, " ").concat(theme.space.XSmall) : "".concat(theme.space.XSmall, " ").concat(theme.space.standard, " ").concat(theme.space.XSmall);
});
var MainBannerDiv = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__MainBannerDiv",
  componentId: "sc-9j6840-3"
})(["display:flex;align-items:centre;justify-content:flex-start;flex-direction:", ";padding:", ";gap:", ";"], function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile ? 'column' : 'row';
}, function (_ref8) {
  var theme = _ref8.theme,
    isMobile = _ref8.isMobile;
  return isMobile ? "".concat(theme.space.XSmall, " ").concat(theme.space.small, " ").concat(theme.space.XSmall) : "".concat(theme.space.XSmall, " ").concat(theme.space.standard, " ").concat(theme.space.XSmall);
}, function (_ref9) {
  var theme = _ref9.theme,
    isMobile = _ref9.isMobile;
  return isMobile ? theme.space.large : theme.space.semiXXXLarge;
});
var ButtonDiv = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__ButtonDiv",
  componentId: "sc-9j6840-4"
})(["display:flex;width:", ";"], function (_ref10) {
  var isMobile = _ref10.isMobile;
  return isMobile ? 'auto' : '40%';
});
var StyledContentNew = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__StyledContentNew",
  componentId: "sc-9j6840-5"
})(["display:flex;align-items:center;justify-content:center;flex:1;white-space:nowrap;"]);
var FooterDiv = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__FooterDiv",
  componentId: "sc-9j6840-6"
})(["display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;padding:", ";"], function (_ref11) {
  var theme = _ref11.theme,
    isMobile = _ref11.isMobile;
  return isMobile ? "".concat(theme.space.small, " ").concat(theme.space.small, " ").concat(theme.space.small) : "".concat(theme.space.small, " ").concat(theme.space.standard, " ").concat(theme.space.small);
});
var IconDiv = _styledComponents.default.span.withConfig({
  displayName: "BookingStatus__IconDiv",
  componentId: "sc-9j6840-7"
})(["display:flex;margin:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.XXXSmall, " ").concat(theme.space.none, "  ").concat(theme.space.tiny);
});
var PaymentDetailsDiv = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__PaymentDetailsDiv",
  componentId: "sc-9j6840-8"
})(["display:flex;flex-direction:row;justify-content:space-between;width:100%;margin-bottom:", ";gap:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.space.XSmall;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.small;
});
var LastPaymentAttemptDiv = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__LastPaymentAttemptDiv",
  componentId: "sc-9j6840-9"
})(["display:flex;flex-direction:row;margin-bottom:", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.XSmall;
});
var PaymentAndRewardContainer = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__PaymentAndRewardContainer",
  componentId: "sc-9j6840-10"
})(["display:flex;flex-direction:", ";width:100%;gap:", ";"], function (_ref16) {
  var isMobile = _ref16.isMobile;
  return isMobile ? 'column' : 'row';
}, function (_ref17) {
  var theme = _ref17.theme,
    isMobile = _ref17.isMobile;
  return isMobile ? theme.space.medium : theme.space.large;
});
var PaymentColumn = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__PaymentColumn",
  componentId: "sc-9j6840-11"
})(["flex:1;display:flex;flex-direction:column;"]);
var RewardColumn = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__RewardColumn",
  componentId: "sc-9j6840-12"
})(["flex:1;display:flex;flex-direction:column;"]);
var DateTimeDiv = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__DateTimeDiv",
  componentId: "sc-9j6840-13"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;margin-bottom:", ";"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.XSmall;
});
var TagWrapper = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__TagWrapper",
  componentId: "sc-9j6840-14"
})(["display:inline-flex;align-items:center;justify-content:center;padding:", ";border-radius:", ";font-size:", ";font-weight:", ";color:", ";background-color:", ";padding:", ";border-radius:", ";white-space:nowrap;"], function (_ref19) {
  var theme = _ref19.theme;
  return "".concat(theme.space.XXSmall, " ").concat(theme.space.XSmall);
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.space.micro;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.fontSize.small;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.fontWeight.medium;
}, function (_ref23) {
  var status = _ref23.status,
    theme = _ref23.theme;
  if (status === _constant.STATE_LIST.FAILED) return theme.colors.tertiaryRed;
  if (status === _constant.STATE_LIST.PROCESSING) return theme.colors.yellow;
  if (status === _constant.STATE_LIST.SUCCESS) return theme.colors.green;
  return theme.colors.greyLight;
}, function (_ref24) {
  var status = _ref24.status,
    theme = _ref24.theme;
  if (status === _constant.STATE_LIST.FAILED) return theme.backgroundColor.redLight;
  if (status === _constant.STATE_LIST.PROCESSING) return theme.backgroundColor.yellowLight;
  if (status === _constant.STATE_LIST.SUCCESS) return theme.backgroundColor.greenLight;
  return theme.colors.greyLight;
}, function (_ref25) {
  var theme = _ref25.theme;
  return "".concat(theme.space.mini, " ").concat(theme.space.micro);
}, function (_ref26) {
  var theme = _ref26.theme;
  return "".concat(theme.space.micro);
});
var PointsRefundNote = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__PointsRefundNote",
  componentId: "sc-9j6840-15"
})(["margin-top:", ";width:100%;"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.space.small;
});
var StyledTimerWrapper = _styledComponents.default.div.withConfig({
  displayName: "BookingStatus__StyledTimerWrapper",
  componentId: "sc-9j6840-16"
})(["display:inline-flex;align-items:center;justify-content:center;padding:", ";margin-left:", ";font-size:", ";font-weight:", ";background-color:", ";padding:", ";border-radius:", ";border:2px solid ", ";white-space:nowrap;"], function (_ref28) {
  var theme = _ref28.theme;
  return "".concat(theme.space.XXSmall, " ").concat(theme.space.XSmall);
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.space.small;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.fontSize.small;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.fontWeight.medium;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.backgroundColor.greenLight;
}, function (_ref33) {
  var theme = _ref33.theme;
  return "".concat(theme.space.mini, " ").concat(theme.space.micro);
}, function (_ref34) {
  var theme = _ref34.theme;
  return "".concat(theme.space.micro);
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.colors.black;
});

// eslint-disable-next-line consistent-return
var getPaymentStatusLabel = function getPaymentStatusLabel(status, language) {
  if (status === _constant.STATE_LIST.FAILED) return language[_constant.PAYMENT_STATUSES.FAILED];
  if (status === _constant.STATE_LIST.PROCESSING) return _constant.PAYMENT_STATUSES.PROCESSING;
  if (status === _constant.STATE_LIST.SUCCESS) return _constant.PAYMENT_STATUSES.REFUNDED;
};
var BookingStatus = function BookingStatus(_ref36) {
  var isMobile = _ref36.isMobile,
    theme = _ref36.theme,
    customProperties = _ref36.customProperties,
    accessible = _ref36.accessible,
    translation = _ref36.translation,
    locale = _ref36.locale,
    data = _ref36.data,
    handleBookingCallback = _ref36.handleBookingCallback,
    isloading = _ref36.isloading,
    onHoldExpired = _ref36.onHoldExpired,
    showRewardPoints = _ref36.showRewardPoints;
  var _useState = (0, _react.useState)(function () {
      return data.holdExpiry ? new Date(data.holdExpiry) < new Date() : false;
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isExpired = _useState2[0],
    setIsExpired = _useState2[1];
  var isValidHoldExpiry = function isValidHoldExpiry(expiry) {
    return expiry && expiry !== 'null' && !Number.isNaN(new Date(expiry));
  };
  (0, _react.useEffect)(function () {
    if (!isValidHoldExpiry(data === null || data === void 0 ? void 0 : data.holdExpiry)) return;
    var expiry = new Date(data.holdExpiry).getTime();
    var now = Date.now();
    if (expiry <= now) return;
    var timeout = setTimeout(function () {
      return setIsExpired(true);
    }, expiry - now);
    // eslint-disable-next-line consistent-return
    return function () {
      return clearTimeout(timeout);
    };
  }, [data.holdExpiry]);
  (0, _react.useEffect)(function () {
    if (isExpired) {
      // eslint-disable-next-line no-unused-expressions
      onHoldExpired === null || onHoldExpired === void 0 || onHoldExpired();
    }
  }, [isExpired, onHoldExpired]);
  var bookingStatus = isExpired ? _constant.BOOKING_STATE.bookingFailed : data.bookingStatus;
  var showTimer = isExpired ? false : data.showTimer;
  if (bookingStatus === _constant.BOOKING_STATE.success || bookingStatus === _constant.BOOKING_STATE.pending) {
    return null;
  }
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  var getText = function getText(_message, _customProperties, _display, _bold, _type, _textAlign, _color) {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: _display,
      color: _color,
      customProperties: _customProperties,
      bold: _bold,
      type: _type,
      textAlign: _textAlign
    }, _message);
  };
  var handleButtonClick = function handleButtonClick(button) {
    handleBookingCallback(button.key);
  };
  var spinnerColor = function spinnerColor() {
    return 'secondary';
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, (0, _extends2.default)({
    isMobile: isMobile
  }, customProperties, {
    tabIndex: !accessible ? '-1' : '0'
  }), /*#__PURE__*/_react.default.createElement(StyledContent, {
    isMobile: isMobile
  }, getText(language[bookingStatus], {
    fontWeight: _constant.TEXT.medium
  }, _constant.TEXT.inlineFlex, true, _constant.TEXT.textLarge, _constant.TEXT.left, _constant.TEXT[bookingStatus]), isValidHoldExpiry(data === null || data === void 0 ? void 0 : data.holdExpiry) && bookingStatus === _constant.BOOKING_STATE.paymentPending && showTimer && /*#__PURE__*/_react.default.createElement(TimerWrapper, {
    showTimer: showTimer
  }, /*#__PURE__*/_react.default.createElement(StyledTimerWrapper, null, /*#__PURE__*/_react.default.createElement(_Timer.default, {
    endDate: (0, _BookingStatusUtils.formatStringDate)(new Date(data.holdExpiry)),
    color: _constant.TEXT.black,
    theme: theme,
    translation: language,
    countDownFormat: true,
    accessible: accessible,
    customProperties: customProperties,
    showHMSFormat: true
  })))), /*#__PURE__*/_react.default.createElement(MainBannerDiv, {
    isMobile: isMobile
  }, isMobile ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getText(bookingStatus === _constant.BOOKING_STATE.paymentPending && data.lastPaymentMethod ? language.payment_pendingMessage : language["".concat(bookingStatus, "Message")], {
    fontWeight: _constant.TEXT.medium
  }, _constant.TEXT.inlineFlex, true, _constant.TEXT.small, _constant.TEXT.left, _constant.TEXT.black), data.button && bookingStatus === _constant.BOOKING_STATE.paymentPending && showTimer && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(ButtonDiv, {
    isMobile: isMobile,
    key: data.button.key
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    boxShadow: true,
    handleClick: function handleClick() {
      return handleButtonClick(data.button);
    },
    width: "100%",
    buttonType: _constant.TEXT.button,
    theme: theme,
    color: data.button.textColor,
    backgroundColor: data.button.bgColor,
    border: "secondary"
  }, isloading ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    animationDuration: "1s",
    color: spinnerColor(),
    height: "18px",
    show: true,
    strokeWidth: "3",
    theme: theme,
    width: "18px"
  }) : /*#__PURE__*/_react.default.createElement(StyledContentNew, null, /*#__PURE__*/_react.default.createElement(IconDiv, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: data.button.textColor,
    accessible: accessible,
    fontsize: _constant.TEXT.secondary,
    icon: data.button.icon,
    theme: theme
  })), getText("".concat(language[data.button.key], " - ").concat(data.currency, " ").concat(data.balanceDue), {}, _constant.TEXT.inlineFlex, false, _constant.TEXT.textLarge, null, data.button.textColor)))))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getText(bookingStatus === _constant.BOOKING_STATE.paymentPending && data.lastPaymentMethod ? language.payment_pendingMessage : language["".concat(bookingStatus, "Message")], {
    fontWeight: _constant.TEXT.medium
  }, _constant.TEXT.inlineFlex, true, _constant.TEXT.small, _constant.TEXT.left, _constant.TEXT.black), data.button && bookingStatus === _constant.BOOKING_STATE.paymentPending && showTimer && /*#__PURE__*/_react.default.createElement(ButtonDiv, {
    isMobile: isMobile,
    key: data.button.key
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    boxShadow: true,
    handleClick: function handleClick() {
      return handleButtonClick(data.button);
    },
    width: "100%",
    theme: theme,
    buttonType: _constant.TEXT.button,
    color: data.button.textColor,
    backgroundColor: data.button.bgColor,
    border: "secondary"
  }, isloading ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    animationDuration: "1s",
    color: spinnerColor(),
    height: "18px",
    show: true,
    strokeWidth: "3",
    theme: theme,
    width: "18px"
  }) : /*#__PURE__*/_react.default.createElement(StyledContentNew, null, /*#__PURE__*/_react.default.createElement(IconDiv, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    color: data.button.textColor,
    accessible: accessible,
    fontsize: _constant.TEXT.secondary,
    icon: data.button.icon,
    theme: theme
  })), getText("".concat(language[data.button.key], "  - ").concat(data.currency, " ").concat(data.balanceDue), {}, _constant.TEXT.inlineFlex, false, _constant.TEXT.textLarge, null, data.button.textColor)))))), /*#__PURE__*/_react.default.createElement(FooterDiv, null, (data.bookingStatus === _constant.BOOKING_STATE.processingPayment || data.bookingStatus === _constant.BOOKING_STATE.paymentPending || data.bookingStatus === _constant.BOOKING_STATE.bookingFailed) && (data === null || data === void 0 ? void 0 : data.lastPaymentMethod) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(LastPaymentAttemptDiv, null, getText(language.lastPaymentAttempt, {
    fontWeight: _constant.TEXT.medium
  }, _constant.TEXT.inlineFlex, true, _constant.TEXT.small, _constant.TEXT.left, _constant.TEXT.black)), /*#__PURE__*/_react.default.createElement(PaymentAndRewardContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(PaymentColumn, null, /*#__PURE__*/_react.default.createElement(PaymentDetailsDiv, null, /*#__PURE__*/_react.default.createElement("div", null, getText("".concat(data.lastPaymentMethod.name), {
    fontWeight: _constant.TEXT.medium
  }, _constant.TEXT.inlineFlex, true, _constant.TEXT.small, _constant.TEXT.left, _constant.TEXT.greyDarker)), /*#__PURE__*/_react.default.createElement("div", null, getText("".concat(data.lastPaymentMethod.currency, " ").concat(data.lastPaymentMethod.amount), {
    fontWeight: _constant.TEXT.medium
  }, _constant.TEXT.inlineFlex, true, _constant.TEXT.small, _constant.TEXT.right, _constant.TEXT.greyDarker))), /*#__PURE__*/_react.default.createElement(DateTimeDiv, null, getText(new Date(data.lastPaymentMethod.dateTime).toLocaleString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }), {
    fontWeight: _constant.TEXT.small
  }, _constant.TEXT.inlineFlex, true, isMobile ? _constant.TEXT.XXXSmall : _constant.TEXT.tiny, _constant.TEXT.left, _constant.TEXT.greyDarker), /*#__PURE__*/_react.default.createElement(TagWrapper, {
    status: data.lastPaymentMethod.status
  }, getPaymentStatusLabel(data.lastPaymentMethod.status, language)))), showRewardPoints && data.bookingStatus === _constant.BOOKING_STATE.bookingFailed && data.rewardPointsMethod && /*#__PURE__*/_react.default.createElement(RewardColumn, null, /*#__PURE__*/_react.default.createElement(PaymentDetailsDiv, null, /*#__PURE__*/_react.default.createElement("div", null, getText(data.rewardPointsMethod.name || language.pointRedemption, {
    fontWeight: _constant.TEXT.medium
  }, _constant.TEXT.inlineFlex, true, _constant.TEXT.small, _constant.TEXT.left, _constant.TEXT.greyDarker)), /*#__PURE__*/_react.default.createElement("div", null, getText("".concat(data.rewardPointsMethod.currency, " ").concat(data.rewardPointsMethod.amount), {
    fontWeight: _constant.TEXT.medium
  }, _constant.TEXT.inlineFlex, true, _constant.TEXT.small, _constant.TEXT.right, _constant.TEXT.greyDarker))), /*#__PURE__*/_react.default.createElement(DateTimeDiv, null, getText(data.rewardPointsMethod.dateTime ? new Date(data.rewardPointsMethod.dateTime).toLocaleString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }) : '', {
    fontWeight: _constant.TEXT.small
  }, _constant.TEXT.inlineFlex, true, isMobile ? _constant.TEXT.XXXSmall : _constant.TEXT.tiny, _constant.TEXT.left, _constant.TEXT.greyDarker), /*#__PURE__*/_react.default.createElement(TagWrapper, {
    status: _constant.STATE_LIST.SUCCESS
  }, getPaymentStatusLabel(_constant.STATE_LIST.SUCCESS, language))), /*#__PURE__*/_react.default.createElement(PointsRefundNote, null, getText(language.pointsRefundNote, {
    fontWeight: _constant.TEXT.medium
  }, _constant.TEXT.inlineFlex, false, _constant.TEXT.small, _constant.TEXT.left, _constant.TEXT.greyDarker))))))));
};
BookingStatus.propTypes = _BookingStatus.default.PropTypes;
BookingStatus.defaultProps = _BookingStatus.default.DefaultProps;
var _default = BookingStatus;
exports.default = _default;